import { Tenant } from './../../../models/tenant.model';
import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-tenant-bills',
  template: `
    <div class="d-flex">
      <div>
        <h1>Recibos</h1>
      </div>
    </div>
    <div class="d-flex">
      <div class="flex-fill list-group rounded-4 shadow mt-4" >
        <div class="list-group-item bg-white ">
          <table class="table table-sm table-hover table-responsive mt-3">
            <thead>
              <tr>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"># Recibo</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 ps-3">Referencia</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 ps-3">Unidad - Condominio / Comercio</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 ps-3">Creado</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 ps-3">Total a pagar</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 ps-3">Estatus</th>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2 ps-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr app-item-bill
                [bill]="bill"
                [profile]="profile"
                [permissions]="permissions"
                *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries}"
              ></tr>
            </tbody>
          </table>
        </div>
        <div class="list-group-item text-center p-5" *ngIf="bills.length==0&&!loading">
          No existen adeudos pendientes.
        </div>
        <div *ngIf="bills.length==0&&loading" class="list-group-item text-center p-5">
          <fa-icon [icon]="faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
          <p class="text-muted">Cargando...</p>
        </div>
        <div class="list-group-item" *ngIf="meta.total_pages > 1">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
              *ngIf="bills.length>0"
            ></pagination-controls>
          </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TenantBillsComponent implements OnInit {
  bills: any = [];
  tenant: any = {};
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  loading: boolean = false;
  searchBox: FormGroup = new FormGroup({});

  apiUrl: string = environment.AWS_REST_WSPREFIX;

  faTimes = faTimes;
  faCircleNotch = faCircleNotch;

  payload: any = {    
    page: 1,
    per_page: 50,
    status: false,
    state: [1]
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor (
    private store : SettlementsService,
    private activateRoute: ActivatedRoute,
    private route: Router,
    private fb: FormBuilder
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    // this.payload.profile = this.profile.id;
  }

  ngOnInit(): void {
    this.loadBills();
    this.initForm(); 
  }

  loadBills() {
    this.loading = true;

    this.activateRoute.params.subscribe((params: any) => {
      this.store.getTenant(params['id']).subscribe((data: any) => {
        this.tenant = data;
        this.payload.unit_id = this.tenant.unit_id; 
        this.payload.status = false;

        console.log('tenant => ', data);

        const units = data.units.map((item: any) => {
          console.log('item => ', item);
          return item.id
        });
        
        console.log('units => ', units);
        this.payload.units = units;
        
        this.store.getBillsByUnits(this.tenant?.id, this.payload).subscribe({
          next: (bills: any) => {
            console.log('bills => ', bills);
            this.bills = bills.data;
            this.meta = bills.meta;
            this.loading = false;
          },
          error: (error: any) => {
            this.bills = [];
            this.loading = false;
          }
        });
      });
    });
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    })
  }

  searchUsers(event: any) {
    this.payload.page = 1;
    this.payload.name = this.searchBox.value.search;
    this.loadBills();
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadBills();
  }

  async downloadReceipt(bill: any) {
    let dueDate = new Date(bill.due_date);
    //
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    this.store.getSubscriptions(bill.subscription_id).subscribe((data: any) => {
      // console.log('getSubscription => ', data);      
      this.store.getUnit(data.unit_id).subscribe((unitData: any) => {
        // console.log('getTenantByUnit => ', data);
        this.store.getBuilding(1).subscribe(async (data: any) => {
          // console.log('getBuilding => ', data);
          if (bill.images && bill.images.length > 0) {
          let imageUrl = `${this.apiUrl}/storage/${bill.images[0].blob.key.substring(0,2)}/${bill.images[0].blob.key.substring(2,4)}/${bill.images[0].blob.key}`
          let imageUrl2 = `${this.apiUrl}/storage/${bill.images[1].blob.key.substring(0,2)}/${bill.images[1].blob.key.substring(2,4)}/${bill.images[1].blob.key}`

          await this.getBase64ImageFromUrl(imageUrl)
          .then(result => {
            let blobed = result;
            bill.image1 = blobed;
          })

          await this.getBase64ImageFromUrl(imageUrl2)
          .then(result => {
            let blobed = result;
            bill.image2 = blobed;
          })
          .catch(err => console.error(err));
        }

          const payload = {
            bill: bill,
            dueDate: dueDate,
            unitData: unitData,
            buildingData: data
          };

          this.store.createReceipt(payload).subscribe({
            next: (data: any) => {
              // console.log('createReceipt => ', data);
              const int8Array = new Uint8Array(data.result.data);
              const blob = new Blob([int8Array], { type: 'application/pdf' });
              let fileURL = window.URL.createObjectURL(blob);
              let link=document.createElement('a');
              //
              link.href = fileURL;
              link.download = data.filename; // filePath.substr(filePath.lastIndexOf('/') + 1);
              link.click();
  
              return;
            }, error: (error: any) => {
              console.log('createReceipt ERROR => ', error);
            }
          });
        });
      });
    });
  }

  async getBase64ImageFromUrl(imageUrl: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
  
    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
  
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }

}
